import { useState } from "react";
import { DictationButton } from "@/components/DictationButton";

export function TextNoteDialog({ onSave, onCancel }) {
  const [txt, setTxt] = useState("");
  return (
    <div className="absolute inset-0 z-30 flex items-center justify-center bg-black/40" data-testid="wsi-text-note-dialog"
         onPointerDown={(e) => e.stopPropagation()} onKeyDown={(e) => { if (e.key === "Escape") onCancel(); }}>
      <div className="w-[min(92vw,420px)] rounded-xl bg-white p-4 shadow-2xl">
        <div className="text-sm font-semibold text-slate-800 mb-2">Note de lecture (annotation texte)</div>
        <textarea autoFocus rows={3} value={txt} onChange={(e) => setTxt(e.target.value)} data-testid="wsi-text-note-input"
                  className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm" placeholder="Tapez ou dictez votre note…" />
        <DictationButton value={txt} onChange={setTxt} testId="dictation-wsi-note" />
        <div className="mt-3 flex justify-end gap-2">
          <button type="button" onClick={onCancel} data-testid="wsi-text-note-cancel" className="px-3 py-1.5 text-sm rounded-lg text-slate-600 hover:bg-slate-100">Annuler</button>
          <button type="button" disabled={!txt.trim()} onClick={() => onSave(txt.trim())} data-testid="wsi-text-note-save"
                  className="px-3 py-1.5 text-sm rounded-lg bg-sky-600 text-white hover:bg-sky-700 disabled:opacity-50">Enregistrer</button>
        </div>
      </div>
    </div>
  );
}
